import React from "react";
import AlertBanner from "./AlertBanner";

interface CreditCardDisabledNoticeProps {
  /** Extra CSS class names forwarded to the underlying banner. */
  readonly className?: string;
}

/**
 * Warns the guest that the venue only accepts debit cards for this booking type.
 *
 * Collins refuses a credit-funded card at capture time, so every flow that takes
 * a card for such a booking shows this first and passes `disableCreditCards` to
 * the payment form, which refuses the card before it is charged.
 */
const CreditCardDisabledNotice: React.FC<CreditCardDisabledNoticeProps> = ({ className = "gcw:mb-bs-3" }) => (
  <AlertBanner
    variant="warning"
    translatedKey="credit_card_disabled_notice"
    messageDefault="Note: credit cards are not accepted for this type of booking. Please use a debit card."
    className={`widget-panel-notice ${className}`}
  />
);

export default CreditCardDisabledNotice;
